export default "__VITE_ASSET__DbvdZmNF__"